import {
  BillableItemStatusSchema,
  type BillableItemStatus,
} from '@duke-hq/svc-api-db/schemas/enums/BillableItemStatus.schema';

export function datesEqual(a?: Date | null, b?: Date | null) {
  if (!a && !b) {
    return true;
  }
  if (!a || !b) {
    return false;
  }
  return a.getTime() === b.getTime();
}

const MAX_DESC_CHARS = 40;

export function truncateDescription(s?: string | null, max = MAX_DESC_CHARS) {
  const text = (s ?? '').trim();
  if (!text) {
    return { short: '', truncated: false };
  }
  if (text.length <= max) {
    return { short: text, truncated: false };
  }

  const slice = text.slice(0, max);
  const lastSpace = slice.lastIndexOf(' ');
  const short = (lastSpace > max * 0.6 ? slice.slice(0, lastSpace) : slice) + '…';
  return { short, truncated: true };
}

// A stable, frozen empty array to avoid new references on each render
export const EMPTY_STATUS: ReadonlyArray<BillableItemStatus> = Object.freeze([]);
export const BILLABLE_STATUS_SET: ReadonlySet<string> = new Set(BillableItemStatusSchema.options);

export function isBillableStatus(status: string): status is BillableItemStatus {
  return BILLABLE_STATUS_SET.has(status);
}
